import { autobind, connect, Component, Rendering } from "macguffin"
import GameMode from "game/modes"
import GameModeGroup from "game/modes/GameModeGroup"

import BackgroundImage from "utils/BackgroundImage"

const { TWEEN } = Rendering
const { min, max } = Math

const EXTRA_SCATTER_SCALE = 0.05

const MeterVisibleGroup = new GameModeGroup([GameMode.RESUME, GameMode.REVERT, GameMode.MAIN, GameMode.COMET_WILDS, GameMode.RESPIN ])

const scatterMeterStyle = {
    backgroundPosition: "center right"
}

const glowStyle = {
    backgroundPosition: "bottom center"
}

@connect(state => ({
    currentGameMode: state.game.currentGameMode,
    currentFreespins: state.game.currentFreespins,
    extraFreespins: state.game.extraFreespins
}), {})

export default class ScatterMeter extends Component {

    componentWillReceiveProps(nextProps) {
        const currentProps = this.props
    }

    render() {
        const { props, state } = this
        const { currentFreespins, extraFreespins, currentGameMode, width, height } = props
        const isMeter = MeterVisibleGroup.contains(currentGameMode)

        const style = {
            width: `${width}px`,
            height: `${height}px`,
            visibility: isMeter ? "visible" : "none"
        }

        const scatterLevels = []
        const scatterLevelStyle = {
            height: `${height / 5}px`,
            backgroundPosition: "bottom center"
        }

        const extraScatters = max(0, extraFreespins)
        const extraScatterStyle = {
            fontSize: `${height * EXTRA_SCATTER_SCALE}px`
        }

        for (let i = 0; i < min(currentFreespins, 5); i++) {
            const isGlowing = currentFreespins > 3 || (i === currentFreespins - 1)
            const showDoubleScatter = currentFreespins > 3
            let level = currentFreespins;
            if (level > 5) { level = 5 }
            const scatterGlowStyle = {
                animationName: isGlowing ? `scatterGlow${level}` : "",
                opacity: isGlowing ? '' : 1,
                animationDuration: `${1.5 - (level * 0.2)}s`
            }

            scatterLevels.push(<BackgroundImage className="scatterMeterLevel" assetName="scatterMeterLevel" key={i} style={scatterLevelStyle}>
                { (extraScatters > 0 && i === 4) && <h1>+{ extraScatters }</h1> }
                <BackgroundImage className="scatterGlow" assetName="scatterMeterGlow" style={{...glowStyle, ...scatterGlowStyle}} />
                { showDoubleScatter && <BackgroundImage className="scatterGlow" assetName="scatterMeterGlow" style={{ ...glowStyle, opacity: 0.5}} /> }
            </BackgroundImage>)
        }

        return <div className="scatterMeterContainer" style={style}>
            { isMeter && <BackgroundImage className="scatterMeter" assetName="scatterMeter" style={scatterMeterStyle}>
                { isMeter && scatterLevels }
            </BackgroundImage>}
        </div>
    }
}
